<template>
  <div>
    <b-table
      ref="personal-leave-application-dt"
      id="personal-leave-application-dt"
      table-class="table-head-custom"
      hover
      :responsive="true"
      :fields="fields"
      :items="items"
      :busy="isBusy"
      show-empty
    >
      <!-- A custom formatted header cell for field 'name' -->
      <template v-slot:head(index)="data">
        <span class="text-dark-75">{{ data.label.toUpperCase() }}</span>
      </template>

      <!-- A virtual column -->
      <template v-slot:cell(index)="data">
        <span class="font-weight-bolder">{{ data.index + 1 }}</span>
      </template>

      <template v-slot:cell(name)="data">
        <div class="d-flex flex-column">
          <span class="font-weight-bolder text-h6">
            {{ data.item.name }}
          </span>
        </div>
      </template>

      <template #table-busy>
        <AppLoader #table-busy></AppLoader>
      </template>

      <template #empty>
        <AppEmptyList
          text-top="No leave applications"
          text-bottom="Go to entitlement to apply leave status."
        ></AppEmptyList>
      </template>
    </b-table>

    <div class="d-flex justify-content-end" v-if="items.length">
      <b-pagination
        v-model="pagination.current_page"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        size="lg"
        pills
        aria-controls="away-entitlement-page-dt"
        @change="handlePageChange"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppLoader from "@/modules/core/components/loaders/AppLoader";
import AppEmptyList from "@/modules/core/components/empty/AppEmptyList";
export default {
  name: "LeavePageApplicationTable",
  props: ["reload"],
  components: {
    AppEmptyList,
    AppLoader,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      isBusy: false,
      fields: [
        {
          key: "name",
          label: this.$t("LEAVE.TYPE"),
          stickyColumn: true,
          variant: "light",
        },
        { key: "from_date", label: this.$t("USERGENERAL.MESSAGE.START") },
        { key: "to_date", label: this.$t("USERGENERAL.MESSAGE.END") },
        { key: "unit.requested", label: this.$t("HOLIDAY.DAY") },
        { key: "reason", label: this.$t("ENTITLEMENT.REASON") },
        { key: "status", label: this.$t("JOB.STATUS") },
      ],
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    cancelLeaveApplication() {},

    /**
     * Fetch the application list
     */
    fetch() {
      this.isBusy = true;
      this.$store
        .dispatch("fetchPersonalLeaveApplicationList")
        .finally(() => (this.isBusy = false));
    },

    /**
     * Change the page event.
     *
     * @param page
     */
    handlePageChange(page) {
      console.log(page);

      this.$store.commit("setPersonalLeaveApplicationListPage", page);
      this.fetch();
    },
  },

  computed: {
    ...mapGetters({
      items: "getPersonalLeaveApplicationList",
      pagination: "getPersonalLeaveApplicationListPagination",
    }),
  },
  watch: {},
};
</script>

<style scoped></style>
